import { Box, Button, Flex, Stack, Switch, UnstyledButton } from '@mantine/core';

import { deleteIcon } from '@assets';
import { AsyncAutocomplete, EucdmCode, TextInput } from './';

interface MultipleContainersProps {
  compact?: boolean;
  containers: string[];
  onChange: (newContainers: string[]) => void;
  onHeaderChange?: (active: boolean) => void;
  headerValue?: boolean;
  editDisabled?: boolean;
  headerDisabled?: boolean;
  label: string;
  'data-pw'?: string;
  fetchOptions?: (search: string) => Promise<any[]>;
  eucdmPath?: string;
}

export const MultipleContainers: React.FC<MultipleContainersProps> = ({ ...props }) => {
  const appendContainer = () => {
    props.onChange([...props.containers, '']);
  };

  const removeContainer = (containerIdx: number) => {
    const newContainerList = [...props.containers];
    newContainerList.splice(containerIdx, 1);
    props.onChange(newContainerList);
  };

  const updateContainer = (containerIdx: number, value: string) => {
    const newContainerList = [...props.containers];
    newContainerList[containerIdx] = value;
    props.onChange(newContainerList);
  };

  return (
    <Stack>
      {props.containers.map((container, containerIdx) => (
        <EucdmCode path={props.eucdmPath}>
          <Flex justify={'flex-start'} mb={15} key={containerIdx}>
            <Box pos="relative" w="100%">
              {props.fetchOptions ? (
                <AsyncAutocomplete
                  label={`${props.label} ${containerIdx + 1}`}
                  onChange={(selectedOption) => updateContainer(containerIdx, selectedOption)}
                  onBlur={(evt) => {
                    updateContainer(containerIdx, evt.target.value);
                  }}
                  fetchOptions={props.fetchOptions}
                  value={container}
                  disabled={props.editDisabled}
                  size={props.compact ? 'xl' : 'lg'}
                  rightSection={
                    props.onHeaderChange ? (
                      <Switch
                        size="xs"
                        checked={props.headerValue}
                        onChange={(event) => props.onHeaderChange(event.currentTarget.checked)}
                        disabled={props.headerDisabled}
                      />
                    ) : null
                  }
                  data-pw={`${props['data-pw']}-${containerIdx}`}
                />
              ) : (
                <TextInput
                  label={`${props.label} ${containerIdx + 1}`}
                  onChange={(evt) => {
                    updateContainer(containerIdx, evt.target.value);
                  }}
                  onBlur={(evt) => {
                    updateContainer(containerIdx, evt.target.value);
                  }}
                  value={container}
                  disabled={props.editDisabled}
                  size={props.compact ? 'xl' : 'lg'}
                  rightSection={
                    props.onHeaderChange ? (
                      <Switch
                        size="xs"
                        checked={props.headerValue}
                        onChange={(event) => props.onHeaderChange(event.currentTarget.checked)}
                        disabled={props.headerDisabled}
                      />
                    ) : null
                  }
                  data-pw={`${props['data-pw']}-${containerIdx}`}
                />
              )}
            </Box>
            {!props.editDisabled && props.containers.length > 1 && (
              <UnstyledButton
                ml={10}
                onClick={(e) => {
                  e.preventDefault();
                  removeContainer(containerIdx);
                }}
              >
                <img src={deleteIcon} />
              </UnstyledButton>
            )}
          </Flex>
        </EucdmCode>
      ))}
      {!props.editDisabled && (
        <Flex justify={'flex-start'} mb={15}>
          <Button
            onClick={(e) => {
              e.preventDefault();
              appendContainer();
            }}
            variant="outline"
            size="lg"
          >
            Add {props.label}
          </Button>
        </Flex>
      )}
    </Stack>
  );
};
